import React from 'react'
import { Avatar, Menu, MenuItem } from '@material-ui/core'
import { AppBar, IconButton, Button } from '@michelin/acid-components'
import MenuIcon from '@material-ui/icons/Menu'
import ExitToAppIcon from '@material-ui/icons/ExitToApp'
import classNames from 'classnames'
import { Link } from "react-router-dom"
import { withStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'
import { Cancel as CancelIcon } from '@material-ui/icons'

const styles = theme => ({
	logo: {
		width: '4rem',
		height: '4rem',
		marginRight: '1rem',
	},
	menuButton: {
		marginRight: '1rem',
	},
	flex: {
		flexGrow: 1,
	},
	leftIcon: {
		marginRight: theme.spacing.unit,
	},
	iconSmall: {
		fontSize: 20,
	},
})

class ErsTopBar extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			anchorEl: null
		}
		this.handleMenu = this.handleMenu.bind(this)
		this.handleClose = this.handleClose.bind(this)
	}

	handleMenu(event) {
		this.setState({ anchorEl: event.currentTarget })
	}

	handleClose() {
		this.setState({ anchorEl: null })
	}

	render() {
		let { classes, logout } = this.props

		return (
			<AppBar fixed>
				<Avatar src="/bib.jpg" style={{ height: '4rem', width: '4rem', marginRight: '1rem' }} />

				<IconButton aria-owns='menu-appbar' aria-haspopup='true' onClick={this.handleMenu} style={{ marginRight: '1rem' }}>
					<MenuIcon />
				</IconButton>

				<Menu
					id="menu-appbar"
					anchorEl={this.state.anchorEl}
					open={Boolean(this.state.anchorEl)}
					onClose={this.handleMenuClose}
					transformOrigin={{
						vertical: 'top',
						horizontal: 'left',
					}}
				>
					{/* <MenuItem component={({ ...props }) => <Link to='/inbound' {...props} />}>
						<SettingsPhoneIcon className={classNames(classes.leftIcon, classes.iconSmall)} />
						Inbound Program Maintenance
					</MenuItem> */}

					<Link to='/' style={{ textDecoration: 'none', outline: 'none', color: 'inherit' }}>
						<MenuItem>
							<CancelIcon className={classNames(classes.leftIcon, classes.iconSmall)} />
							Return to Main Screen
						</MenuItem>
					</Link>

					{logout &&
						<MenuItem onClick={() => logout()}>
							<ExitToAppIcon className={classNames(classes.leftIcon, classes.iconSmall)} />
							Logout
						</MenuItem>
					}
				</Menu>

				<div style={{ display: 'inline-block', flexGrow: 1 }}>
					<span style={{ fontWeight: 700, marginRight: '.5rem' }}>ERS Profile</span>
					<span>Inbound Program Maintenance</span>
				</div>

				{/* <Typography align="right" color="inherit" className={[classes.flex, classes.userInfo].join(' ')}>
					Welcome, {this.props.username}
				</Typography> */}

				<Link to='/' style={{ textDecoration: 'none', outline: 'none', color: 'inherit' }}>
					<Button color="primary">
						<CancelIcon className={classNames(classes.leftIcon, classes.iconSmall)} />
						Return to Main Screen
					</Button>
				</Link>
			</AppBar>
		)
	}
}

ErsTopBar.propTypes = {
	classes: PropTypes.object,
	logout: PropTypes.func,
}

export default withStyles(styles)(ErsTopBar)


// WEBPACK FOOTER //
// ./src/components/ErsTopBar.js